import { gql } from "@apollo/client";

// Queries

export const GET_CONTRACT_BY_ID_CLIENT = gql`
  query getAllContractByIdClient($idClient: Int!, $nombre: String) {
    getAllContractByIdClient(idClient: $idClient, nombre: $nombre) {
      message
      statusCode
      error
      response
    }
  }
`;

export const GET_COMPANIES = gql`
  query getCompany {
    getCompany {
      statusCode
      message
      error
      response
    }
  }
`;

export const GET_CONTRACT = gql`
  query getAllContractById($idContract: Int!) {
    getAllContractById(idContract: $idContract) {
      message
      statusCode
      error
      response
    }
  }
`;

export const GET_CONTRACTS_SEARCH = gql`
  query getContractsSearch($nameContract: String!) {
    getContractsSearch(nameContract: $nameContract) {
      statusCode
      message
      response
    }
  }
`;

export const GET_TYPES_COINS = gql`
  query getTypeCoin {
    getTypeCoin {
      statusCode
      message
      error
      response
    }
  }
`;

export const GET_CONTRACTS_STATUS = gql`
  query getContractStatus {
    getContractStatus {
      statusCode
      message
      error
      response
    }
  }
`;

export const GET_RAMOS = gql`
  query getRamos {
    getRamos {
      statusCode
      message
      error
      response
    }
  }
`;

export const GET_SINIESTERS = gql`
  query getSiniestros {
    getLastFiveSiniestros {
      statusCode
      message
      error
      response
    }
  }
`;

export const GET_REMINDERS = gql`
  query getReminders {
    getReminders {
      statusCode
      message
      error
      response
    }
  }
`;

// Mutations
export const CREATE_CLIENT = gql`
  mutation createClient($nombre: String!) {
    createClient(nombre: $nombre) {
      statusCode
      message
      error
      response
    }
  }
`;

export const CREATE_CONTRACT = gql`
  mutation createContract($input: contractInput) {
    createContract(input: $input) {
      statusCode
      message
      error
      response
    }
  }
`;

export const UPDATE_STATUS_CONTRACT = gql`
  mutation updateStatusContract($idContract: Int!, $idStatus: Int!) {
    updateStatusContract(idContract: $idContract, idStatus: $idStatus) {
      statusCode
      message
      error
      response
    }
  }
`;
